import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Spinner, VStack } from "native-base";
import ReviewContainer from "../../../../containers/reviewBody";
import { Toaster } from "../../../../components/toaster";
import { getQuickLinkReviewsAPI } from "../../../../api/apis/quicklinks";
import NoDataFound from "../../../../components/noDataFound";
import { COLORS } from "../../../../utils/colors";

const NewReviewList = () => {
  const toaster = Toaster();
  const [reviews, setReviews] = useState([]);
  const { activeTab } = useSelector((state) => {
    return state.event;
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getQuickLinkReviews();
  }, [activeTab]);

  const getQuickLinkReviews = async () => {
    setIsLoading(true);
    let res = await getQuickLinkReviewsAPI(activeTab);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let data = [];
      res &&
        res.data.data.data.image_review_details?.map((item) => {
          let review = {
            name: item?.event_name,
            review: item.event_based_datas?.map((rev) => {
              return {
                rating: rev.rating,
                review: rev.review,
                reviewPayload: rev,
              };
            }),
          };
          data.push(review);
        });
      setReviews(data);
    }
    setIsLoading(false);
  };

  const getReviewAverage = (reviewData) => {
    if (reviewData) {
      let rating = 0;
      let count = 0;
      let total = [0, 0, 0, 0, 0];
      if (reviewData.review) {
        reviewData.review.map((rev) => {
          if (
            rev.reviewPayload.status !== "pending" &&
            rev.reviewPayload.status !== "review_rejected"
          ) {
            count = count + 1;
            rating = rating + parseFloat(rev.reviewPayload.rating);
            total[Math.floor(rev.reviewPayload.rating) - 1] =
              total[Math.floor(rev.reviewPayload.rating) - 1] + 1;
          }
        });
        let average = rating / count;
        average = parseFloat(average.toFixed(1));
        if (average > 5) {
          average = 5;
        }
        if (average) return [average, count, total];
        return [0, count, total];
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <Box mt={10} flex={1} alignItems="center" justifyContent="center">
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : (
        <VStack space={5} height={"100%"}>
          {reviews.length > 0 ? (
            reviews.map((item, ind) => {
              let review = getReviewAverage(item);
              return (
                <VStack>
                  <ReviewContainer
                    review={item}
                    totalRated={review[1]}
                    totalReview={review[2]}
                    totalReviewCount={review[0]}
                    ind={ind}
                  />
                </VStack>
              );
            })
          ) : (
            <NoDataFound dataName="review" />
          )}
        </VStack>
      )}
    </>
  );
};

export default NewReviewList;
